// HistoryModifier.jsx
import React from 'react';
import PropTypes from 'prop-types';
import {
  getIsOnAndroidWebview,
  getIsOnIOSWebview,
  getIsInPwa,
} from '../resource/getUserAgent.js';
import { getIsChinaPartner } from '../resource/partner.js';
import getIsMatchedPathname from '../resource/getIsMatchedPathname.js';

class HistoryModifier extends React.PureComponent {
  handlePopState = () => {
    const { closeInappWebView } = this.props;
    const state = history.state;
    if ('root' === state?._init) {
      if (getIsOnAndroidWebview() || getIsOnIOSWebview()) {
        closeInappWebView();
      } else {
        history.pushState(null, '', '/');
      }
    }
  };

  componentDidMount() {
    const { pathname, route, previousRoute } = this.props;
    if (!getIsInPwa() || '/' !== pathname) {
      if (null === previousRoute) {
        if (
          !getIsOnAndroidWebview() &&
          !getIsOnIOSWebview() &&
          !getIsChinaPartner() &&
          !(
            document.referrer &&
            getIsMatchedPathname({
              pathname: new URL(document.referrer, location.origin).pathname,
              dataKey: 'isOnNext',
            })
          )
        ) {
          history.replaceState({ _init: 'root' }, '', '/');
          const url = new URL(`${location.protocol}//${location.host}${route}`);
          history.pushState(null, '', `${url.pathname}${url.search}`);
        }
      }
      window.addEventListener('popstate', this.handlePopState, false);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  }

  render() {
    return null;
  }
}

HistoryModifier.propTypes = {
  pathname: PropTypes.string,
  route: PropTypes.string,
  previousRoute: PropTypes.string,
  closeInappWebView: PropTypes.func,
};

HistoryModifier.defaultProps = {
  pathname: '/',
  route: '/',
  previousRoute: null,
  closeInappWebView: () => {},
};

export default HistoryModifier;
